export enum ProductType {
    CustomFlowerBouquets = 'Custom Flower Bouquets',
    DesignerFlowerArrangement = 'Designer Flower Arrangements',
    SetBouquets = 'Set Bouquets',
    WeddingFunction = 'Wedding Function',
    SpecialEdition = 'Special Edition',
    Unknown = 'Unknown',
    Ad = 'Ad',
};